import React from "react";
import { Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  LocalShipping,
  ShoppingCart,
  InventoryRounded,
  ReceiptRounded,
} from "@mui/icons-material";
import WidgetCard from "../components/WidgetCard.tsx";

const ApplicationsWidget: React.FC = () => {
  const navigate = useNavigate();

  return (
    <WidgetCard title="Applications">
      <Box sx={{ mt: 0 }}>
        <Button
          fullWidth
          variant="contained"
          startIcon={<LocalShipping />}
          sx={{ mb: 1 }}
          onClick={() => navigate("/orders")}
        >
          ORDERS
        </Button>
        <Button
          fullWidth
          variant="contained"
          startIcon={<ShoppingCart />}
          sx={{ mb: 1 }}
          onClick={() => navigate("/quotes")}
        >
          QUOTE HUB
        </Button>
        <Button
          fullWidth
          variant="contained"
          startIcon={<InventoryRounded />}
          sx={{ mb: 1 }}
          onClick={() => navigate("/load-board")}
        >
          LOAD BOARD
        </Button>
        <Button
          fullWidth
          variant="contained"
          startIcon={<ReceiptRounded />}
          onClick={() => navigate("/invoice")}
        >
          INVOICE HUB
        </Button>
      </Box>
    </WidgetCard>
  );
};

export default ApplicationsWidget;
